import { reactive, toRefs } from '@vue/composition-api';
import { useStore } from '@/utils/use-store';
import {Schedule, Session} from '@/helpers/types'

export function useSchedule() {
  const store = useStore();
  const { accessToken: token } = store.state.user;

  const { ServiceFactory } = require('@/service/ServiceFactory');
  const instance = ServiceFactory.get('schedule');

  const state = reactive({
    scheduleList: [] as any[],
    createDialog: false,
    editDrawer: false,
    tempSchedule: {
      sessions: [] as Session[],
      users: [] as any[],
    } as Schedule,
    userList: [] as any[],
  });

  /**
   * Fetch schedule items from API
   * */
  async function fetchSchedules() {
    try {
      const { data } = await instance.list(token);
      state.scheduleList = data;
    } catch (e) {
      throw e;
    }
  }

  /**
   * Fetch users from API
   * */
  async function fetchUsers() {
    try {
      const { data } = await instance.userList(token);
      state.userList = data;
    } catch (e) {
      throw e;
    }
  }

  /**
   * Handler fro create schedule event
   * @param {any} payload
   * */
  async function createSchedule(payload: any) {
    try {
      const { data: item } = await instance.createSchedule(token, payload);
      state.scheduleList = [...state.scheduleList, item];
      state.createDialog = false;
    } catch (e) {
      throw e;
    }
  }

  /**
   * Handler for toggle-edit event
   * @param {number} id
   * */
  function toggleEditEventHandler(id: number) {
    state.editDrawer = true;
    state.tempSchedule = state.scheduleList.find(schedule => schedule.id === id);
  }

  /**
   * Handler for close edit form event
   * */
  function cloeEditFormEventHandler() {
    state.editDrawer = false;
    state.tempSchedule = {
      sessions: [] as Session[],
      users: [] as any[],
    } as Schedule;
  }

  async function editScheduleEventHandler(payload: any) {
    try {
      await instance.updateSchedule(token, state.tempSchedule.id, payload);
      cloeEditFormEventHandler();
      await fetchSchedules();
    } catch (e) {
      throw e;
    }
  }

  return {
    ...toRefs(state),
    fetchSchedules,
    createSchedule,
    toggleEditEventHandler,
    cloeEditFormEventHandler,
    fetchUsers,
    editScheduleEventHandler,
  };
}
